import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import classnames from "classnames";

import { WhiteBox } from "components/flink-play";
import classes from "./MathRodsProgress.module.scss";

const ProblemsProgress = ({ problemsNumber, problemsLeft, activeIndex, onSelect, disabled = false, labelForSegment = num => `Segment ${num + 1}` }) => {
  // Opt-in segment navigation reuses the shared progress component. Existing
  // templates keep their passive answered-problem indicators unchanged.
  if (onSelect) return <nav className={classes.segmentNavigation} aria-label="Activity segments">
    {_.times(problemsNumber, Number).map(num => <button key={num} type="button"
      className={classnames(classes.segmentBox, { [classes.currentSegment]: num === activeIndex })}
      aria-label={labelForSegment(num)} title={labelForSegment(num)}
      aria-current={num === activeIndex ? 'step' : undefined}
      disabled={disabled} onClick={() => onSelect(num)}>{num + 1}</button>)}
  </nav>;
  const answered =
    problemsLeft !== undefined ? problemsNumber - problemsLeft : 0;

  const formattedAnswered = _.isFinite(answered)
    ? _.times(answered, _.constant(true))
    : [];

  return (
    <WhiteBox outerClass={classes.wrapper} innerClass={classes.inner}>
      <ul className={classes.list}>
        {_.times(problemsNumber, Number).map(num => (
          <li
            key={num}
            className={classnames({
              [classes["filled"]]: formattedAnswered[num]
            })}
          />
        ))}
      </ul>
    </WhiteBox>
  );
};

ProblemsProgress.propTypes = {
  problemsNumber: PropTypes.number.isRequired,
  problemsLeft: PropTypes.number,
  activeIndex: PropTypes.number,
  onSelect: PropTypes.func,
  disabled: PropTypes.bool,
  labelForSegment: PropTypes.func
};

export default ProblemsProgress;
